import React, { useState } from "react";
import { Col, Form } from "react-bootstrap";
import Vouchers from "./Vouchers";
import Layout from "../../../app/Layout.js";
import FiltroProyectos from "../../components/Utils/Filtros/FiltroProyectos.js";

const MESES = [
  { value: '1',  label: 'Enero' },
  { value: '2',  label: 'Febrero' },
  { value: '3',  label: 'Marzo' },
  { value: '4',  label: 'Abril' },
  { value: '5',  label: 'Mayo' },
  { value: '6',  label: 'Junio' },
  { value: '7',  label: 'Julio' },
  { value: '8',  label: 'Agosto' },
  { value: '9',  label: 'Septiembre' },
  { value: '10', label: 'Octubre' },
  { value: '11', label: 'Noviembre' },
  { value: '12', label: 'Diciembre' },
];

const anioActual = new Date().getFullYear();
const ANIOS = Array.from({ length: anioActual - 2023 }, (_, i) => String(2024 + i));

const RegistroVouchers = () => {
  const [datosBusqueda, setDatosBusqueda] = useState({});
  const [filtroEstado,  setFiltroEstado]  = useState('');
  const [filtroAnio,    setFiltroAnio]    = useState('');
  const [filtroMes,     setFiltroMes]     = useState('');

  return (
    <Layout>
      <div className="registro-vouchers-container">
        <h1>Vouchers</h1>
        <div className="box">
          <div className="box-body">
            <FiltroProyectos setValores={setDatosBusqueda}>

              {/* Filtros dentro del mismo Form.Row — misma línea, sin conflictos */}
              <div className="d-flex align-items-end" style={{ gap: '12px' }}>

                <div>
                  <Form.Label style={{ fontSize: '12px' }}>Año</Form.Label>
                  <Form.Control
                    as="select"
                    size="sm"
                    value={filtroAnio}
                    onChange={(e) => { setFiltroAnio(e.target.value); setFiltroMes(''); }}
                  >
                    <option value="">Todos</option>
                    {ANIOS.map(a => <option key={a} value={a}>{a}</option>)}
                  </Form.Control>
                </div>

                <div>
                  <Form.Label style={{ fontSize: '12px' }}>Mes</Form.Label>
                  <Form.Control
                    as="select"
                    size="sm"
                    value={filtroMes}
                    onChange={(e) => setFiltroMes(e.target.value)}
                    disabled={!filtroAnio}
                  >
                    <option value="">Todos</option>
                    {MESES.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                  </Form.Control>
                </div>

                <div>
                  <Form.Label style={{ fontSize: '12px' }}>Estado</Form.Label>
                  <Form.Control
                    as="select"
                    size="sm"
                    value={filtroEstado}
                    onChange={(e) => setFiltroEstado(e.target.value)}
                  >
                    <option value="">Todos</option>
                    <option value="1">Registrado</option>
                    <option value="2">Pendiente</option>
                    <option value="3">Anulado</option>
                  </Form.Control>
                </div>

                {(filtroAnio || filtroMes || filtroEstado) && (
                  <div className="d-flex align-items-end">
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => { setFiltroAnio(''); setFiltroMes(''); setFiltroEstado(''); }}
                    >
                      × Limpiar
                    </button>
                  </div>
                )}

              </div>

            </FiltroProyectos>
          </div>
        </div>

        <Vouchers
          id_proyecto={datosBusqueda?.idEvento || 0}
          filtroEstado={filtroEstado}
          filtroAnio={filtroAnio}
          filtroMes={filtroMes}
        />
      </div>
    </Layout>
  );
};

export default RegistroVouchers;
